import * as React from "react";
const SvgPencil = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m19.455 6.313-.884.884-1.768-1.768.884-.884a.25.25 0 0 1 .354 0l1.414 1.414a.25.25 0 0 1 0 .354ZM8.495 19.394 19.102 8.788l1.414-1.415a1.75 1.75 0 0 0 0-2.474l-1.414-1.415a1.75 1.75 0 0 0-2.475 0L15.212 4.9 4.614 15.497a.742.742 0 0 0-.193.31l-1.41 4.234a.75.75 0 0 0 .948.949l4.226-1.409a.747.747 0 0 0 .31-.187ZM15.743 6.49l1.768 1.767-9.546 9.546-1.768-1.768 9.546-9.545ZM4.908 19.092l.556-1.668 1.112 1.112-1.668.556Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPencil;
